import * as React from "react";
import { t } from "i18next";
import { EntityEditorModal } from "src/components/EntityEditor";
import { EntityCardStore } from "src/pages/EntityCardPage/EntityCardStore";
import { ZEntity } from "src/types/ZEntity";
import { ZUid } from "src/types/zUid";
import { cvtError, onError } from "src/common/onError";
import { EdCardValues } from "src/pages/EntityCardPage/apiEntityCard";
import { createPlanning2Task } from "../apiPlanning2";
import { ZPlanning2Settings } from "../ZPlanning2Settings";

type PropsPlanning2NewTask = {
  open: boolean;
  close: () => void;
  settings: ZPlanning2Settings;
  objectServiceId: ZUid;
  modelEntityId: ZUid;
  onSuccess: () => void;
};

export const Planning2NewTask: React.FC<PropsPlanning2NewTask> = (props) => {
  const { open, close, settings, objectServiceId, modelEntityId, onSuccess } =
    props;
  const [store, setStore] = React.useState<EntityCardStore | null>(null);
  React.useEffect(() => {
    if (open) {
      try {
        const {
          taskObjectId,
          relationLinkAttributeId,
          taskTypeTaskDictionaryValueId,
          taskTypeAttributeId,
        } = settings;
        if (!taskObjectId) throw Error("Не настроено taskObjectId");
        const fnCreate = async (taskEntity: ZEntity): Promise<ZEntity> =>
          createPlanning2Task(objectServiceId, modelEntityId, taskEntity);
        const newStore = new EntityCardStore({ fnCreate });
        const vars: EdCardValues = {};
        if (relationLinkAttributeId) {
          vars[relationLinkAttributeId] = [String(modelEntityId)];
        }
        if (taskTypeAttributeId && taskTypeTaskDictionaryValueId) {
          vars[taskTypeAttributeId] = [String(taskTypeTaskDictionaryValueId)];
        }
        newStore.initNew(taskObjectId, vars);
        setStore(newStore);
      } catch (e) {
        onError(cvtError(e));
        setStore(null);
        close();
      }
    } else {
      setStore(null);
    }
  }, [open]);
  return (
    <EntityEditorModal
      store={store}
      modalProps={{
        open,
        onCancel: close,
      }}
      editorProps={{
        submitText: t("Create"),
        onSuccess,
      }}
    />
  );
};
